import createTransaction from './create/transaction'
import createVisitor from './create/visitor'

const schemas = {
  createTransaction,
  createVisitor
}

export default schemas
